import { format, parseISO } from 'date-fns'
import { isJsonString } from 'Utilities'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'

export const getClosedIconMessagesToday = () => {
  const noClosedMessages =
    !triplaLocalStorage.getItem('closed_icon_message_ids') ||
    !isJsonString(triplaLocalStorage.getItem('closed_icon_message_ids'))
  if (noClosedMessages) return []

  return JSON.parse(triplaLocalStorage.getItem('closed_icon_message_ids'))
}

export const appendClosedToLocalStorage = (message) => {
  let closedIds = []
  if (
    triplaLocalStorage.getItem('closed_icon_message_ids') &&
    triplaLocalStorage.getItem('closed_icon_message_ids').length &&
    isJsonString(triplaLocalStorage.getItem('closed_icon_message_ids'))
  ) {
    closedIds = JSON.parse(triplaLocalStorage.getItem('closed_icon_message_ids'))
  }

  if (!closedIds.find((m) => m.id === message.id)) {
    closedIds.push({ id: message.id, last_closed: new Date() })
  }

  triplaLocalStorage.setItem('closed_icon_message_ids', JSON.stringify(closedIds))
}

export const iconMessageClosedToday = (message) => {
  const noClosedMessages =
    !triplaLocalStorage.getItem('closed_icon_message_ids') ||
    !triplaLocalStorage.getItem('closed_icon_message_ids').length ||
    !isJsonString(triplaLocalStorage.getItem('closed_icon_message_ids'))
  if (noClosedMessages) return false

  const closedMessages = JSON.parse(triplaLocalStorage.getItem('closed_icon_message_ids'))

  const closedToday = closedMessages.find((m) => {
    const idExist = m.id === message.id
    const closedDay = format(parseISO(m.last_closed), 'yyyy-MM-dd')
    const today = format(new Date(), 'yyyy-MM-dd')
    const sameDay = closedDay === today

    if (idExist && !sameDay) {
      popClosedMessage(message.id)
    }

    return idExist && sameDay
  })

  return closedToday
}

function popClosedMessage(messageId) {
  const closedIds = JSON.parse(triplaLocalStorage.getItem('closed_icon_message_ids'))

  const pop = closedIds.filter((c) => c.id !== messageId)
  triplaLocalStorage.setItem('closed_icon_message_ids', JSON.stringify(pop))
}
